import mrpStyles from './../mrp.json'

export default {
  name: '3',
  type: 'Label',
  default: {
    color: mrpStyles.colors.SecondaryGreyMetal,
    borderBottom: `1px solid ${mrpStyles.colors.SecondaryGreyMetal}`
  },
  hover: {
    color: mrpStyles.colors.SecondaryGreySky,
    borderBottom: `1px solid ${mrpStyles.colors.SecondaryGreySky}`
  },
  disabled: {
    color: mrpStyles.colors.PrimaryGrey,
    borderBottom: `1px solid ${mrpStyles.colors.PrimaryGrey}`
  }
}
